import { CreditCard, Lock } from 'lucide-react';
import React from 'react';
import { Button } from '../../../components/ui/button';

interface IProps {
  onAdd: () => void;
}

/** Home's invitation to link a first payment method. */
const NoPaymentMethodCard: React.FC<IProps> = ({ onAdd }) => (
  <div className="px-4 sm:px-6 lg:px-8">
    <section
      className="max-w-md rounded-2xl border border-gray-200 bg-white p-5 shadow-sm"
      aria-labelledby="no-payment-method-title"
    >
      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#E3F2EA] text-[#2E6B4F]">
        <CreditCard className="h-5 w-5" aria-hidden="true" />
      </span>
      <h2
        id="no-payment-method-title"
        className="mt-4 text-lg font-bold text-gray-900"
      >
        Pay with your face.
      </h2>
      <p className="mt-1 text-sm text-gray-500">
        Link a card or wallet for a seamless checkout.
      </p>
      <Button
        onClick={onAdd}
        className="mt-5 h-11 w-full rounded-full bg-[#5CB891] text-primary-foreground hover:bg-[#5CB891]/80"
      >
        <span className="text-sm font-semibold">Add a payment method</span>
      </Button>
      <p className="mt-3 flex items-center gap-1.5 text-xs text-gray-500">
        <Lock className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        Stores never see your card or account details
      </p>
    </section>
  </div>
);

export default NoPaymentMethodCard;
